import { FunctionComponent } from 'react';
import { HasChildren } from 'src/common/props';

export interface HeroContentProps extends HasChildren {}

export const HeroContent: FunctionComponent<HeroContentProps> = ({ children }) => {
    return <main>{children}</main>;
};
